import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../config/config";


export const MaintenanceRequestTenant = createAsyncThunk(
  "dummyData/MaintenanceRequestTenant",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/add-maintenance-request`,
        formData, // <-- Correct
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("ots_token")}`,
            // ❌ DO NOT SET "Content-Type"
          },
        }
      );

      return response.data;

    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

  
  



const CreateTenantMaintenanceRequest = createSlice({
  name: "CreateTenantMaintenanceRequest",
  initialState: {
    loading: false,
    CreateTenantMaintenanceRequest: [],
    error: "",
  },
  extraReducers: (builder) => {
    builder
      .addCase(MaintenanceRequestTenant.pending, (state) => {
        state.loading = true;
      })
      .addCase(MaintenanceRequestTenant.fulfilled, (state, action) => {
        state.loading = false;
        state.CreateTenantMaintenanceRequest = action.payload;
      })
      .addCase(MaintenanceRequestTenant.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export default CreateTenantMaintenanceRequest.reducer;